import { render, staticRenderFns } from "./accessories.vue?vue&type=template&id=6b5633fd&scoped=true"
import script from "./accessories.vue?vue&type=script&lang=js"
export * from "./accessories.vue?vue&type=script&lang=js"
import style0 from "./accessories.vue?vue&type=style&index=0&id=6b5633fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5633fd",
  null
  
)

export default component.exports